import React, { Component } from "react";
import PropTypes from "prop-types";
import { List } from "antd";
import { MENU_REPORT_ACTIONS } from "../_utils/constants";
///import { IconLight } from "../../components";
//import { CoreReportInfo } from "../core_report_info";

class CoreReporMenu extends Component {
  state = {
    reports: this.props.reports
  };

  componentWillReceiveProps(newProps) {
    if (this.state.reports !== newProps.reports)
      this.setState({ reports: newProps.reports });
  }

  onListItemClick = (itemValue, action) => () => {
    if (itemValue && action) this.props.onMenuReportAction(itemValue, action);
  };

  onListItemMouseEnter = itemValue => () => {
    this.setState({
      activeHoverItem: itemValue
    });
  };
  onListItemMouseLeave = itemValue => () => {
    this.setState({
      activeHoverItem: null
    });
  };

  render() {
    const { reports, activeHoverItem } = this.state;
    return (
      <div>
        <div>
          <List
            header={<h3 style={{ padding: "0 8px" }}>Reports Catalogue</h3>}
            dataSource={Object.keys(reports)}
            renderItem={rValue => (
              <List.Item
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  backgroundColor:
                    activeHoverItem === rValue ? "#eee" : "inherit"
                }}
                onMouseEnter={this.onListItemMouseEnter(rValue)}
                onMouseLeave={this.onListItemMouseLeave(rValue)}
                // actions={[
                //   <IconLight
                //     title={"Delete report"}
                //     icon={"trash-alt"}
                //     onClick={onListItemClick(rValue, MENU_REPORT_ACTIONS.DELETE)}
                //   />
                // ]}
              >
                <span
                  style={{ display: "inline-block", width: "100%" }}
                  title={"Add to report"}
                  onClick={this.onListItemClick(
                    rValue,
                    MENU_REPORT_ACTIONS.ADD
                  )}
                >
                  {/*<CoreReportInfo report={reports[rValue]} />*/}

                  {reports[rValue].name}
                </span>
                {/*{activeHoverItem === rValue && (*/}
                {/*<span*/}
                {/*style={{*/}
                {/*display: "inline-block",*/}
                {/*width: "20%",*/}
                {/*textAlign: "right"*/}
                {/*}}*/}
                {/*onClick={this.onListItemClick(*/}
                {/*rValue,*/}
                {/*MENU_REPORT_ACTIONS.DELETE*/}
                {/*)}*/}
                {/*>*/}
                {/*<IconLight title={"Delete report"} icon={"trash-alt"} />*/}
                {/*</span>*/}
                {/*)}*/}
              </List.Item>
            )}
          />
        </div>
      </div>
    );
  }
}

CoreReporMenu.propTypes = {
  reports: PropTypes.object.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
  onMenuReportAction: PropTypes.func.isRequired
};
export default CoreReporMenu;



// WEBPACK FOOTER //
// ./src/views/core/core_report_menu/CoreReportMenu.jsx